export default __webpack_public_path__ + "static/media/one-week-sprint-1.658771d6.svg";